import { PopoverOption } from "bootstrap";
import { SiteMetricDetail, SiteMetricSummary } from "../../scripts/site-activation.entities";


export type SiteCardData = {
    studyId: number;
    studyName: string;
    metricId: number;
    metricName: string;
    inPlayId: number;
    orderBy: number;
    yellowDays?: number;
    redDays?: number;
    completed?: SiteMetricSummary;
    inProgress?: SiteMetricSummary;
    sites?: SiteMetricDetail[];
    trial: string;
    appendixA: number;
    appendixB: number;
}

export class DashboardCard extends HTMLElement {
    cardData = {} as SiteCardData;
    detailsTabState = true;
    isOpen = false;
    yellowDays: any;
    redDays: any;
    studybg: string;
    studybglight: string;
    studyborder: string;
    inProgress: any;
    completed: any;
    inProgressCount: any;
    completedCount: any;
    stoplightMax: any;
    minDays: any;
    plotMin: number;
    maxDays: any;
    plotMax: number;
    greenSites: any;
    yellowSites: any;
    redSites: any;
    completedSites: any;
    inprogressTab: any;
    inprogressTabContent: any;
    completedTab: any;
    completedTabContent: any;

    constructor() {
        super();
    }

    connectedCallback() {

        this.initializeData();

        this.render();

        const summary = this.querySelector('.dsa-summary');
        const details = $(this.querySelector('.dsa-details'));

        summary.addEventListener('click', () => {

            this.isOpen = !details.hasClass('show')
            details.collapse('toggle');

            if (this.isOpen) {
                summary.classList.add('open');
            } else {
                summary.classList.remove('open');
            }
        });

        // Only show popover if there is data
        if (this.inProgressCount > 0) {
            $(this.querySelector('.dsa-timeline-plot-top')).popover(
                this.getPopoverOptions(this.inProgress, 'In-Progress')
                );
        }

        // Only show popover if there is data
        if (this.completedCount > 0) {
            $(this.querySelector('.dsa-timeline-plot-bottom')).popover(
                this.getPopoverOptions(this.completed, 'Completed')
                );
        }

        this.inprogressTab = this.querySelector('.inprogress-tab');
        this.inprogressTabContent = this.querySelector('.inprogress-tab-content');
        this.completedTab = this.querySelector('.completed-tab');
        this.completedTabContent = this.querySelector('.completed-tab-content');

        this.inprogressTab.addEventListener('click', () => {
            this.detailsTabState = true;
            this.updatedDetailsTabs();
        });

        this.completedTab.addEventListener('click', () => {
            this.detailsTabState = false;
            this.updatedDetailsTabs();
        });

        $(this.querySelectorAll('[data-toggle="tooltip"]')).tooltip();

    }

    render() {

        const inProgressPlotMarkup = `
            <div class="dsa-timeline-plot dsa-timeline-plot-top">
                ${(this.inProgressCount > 0) ? this.getPlotMarkup(this.inProgress, true) : this.getPlotMarkupNoData() }
            </div>
            `;

        const completedPlotMarkup = `
            <div class="dsa-timeline-plot dsa-timeline-plot-bottom">
                ${(this.completedCount > 0) ? this.getPlotMarkup(this.completed, false) : ''}
            </div>
            `;

        const inProgressPercent = (this.inProgressCount / (this.inProgressCount + this.completedCount)) * 100 || 0;
        const completedPercent = (this.completedCount / (this.inProgressCount + this.completedCount)) * 100 || 0;

        this.innerHTML = `
        <div class="dsa-card">
            <div class="dsa-summary">
                <div class="dsa-header">
                    <div class="dsa-header-study ${this.studybg}">${this.cardData.studyName}-${this.cardData.trial}</div>
                    <div class="dsa-header-title ${this.studyborder}">${this.cardData.metricName}</div>
                </div>
                <div class="dsa-overview">
                    <div class="dsa-stoplight">
                        <div class="dsa-stoplight-title">In Progress Sites</div>
                        <div class="dsa-stoplight-bars">
                            ${this.getStoplightMarkup()}
                        </div>
                    </div>

                    <div class="dsa-timeline">
                        <div class="dsa-timeline-label">
                            <span class="dsa-timeline-label-count">${this.inProgressCount}</span> <span class="dsa-timeline-label-percent">(${inProgressPercent.toFixed()}%)</span> Sites <br>In-Progress
                        </div>
                        ${inProgressPlotMarkup}
                        <div class="dsa-timeline-days-line">${this.maxDays} days</div>
                        <div class="dsa-timeline-label-line"></div>
                        <div class="dsa-timeline-plot-line"></div>
                        <div class="dsa-timeline-label">
                            ${this.getCompletedLabelMarkup(completedPercent)}
                        </div>
                        ${completedPlotMarkup}
                    </div>

                </div>
            </div>
            <div class="dsa-details collapse">
                <ul class="nav nav-tabs mb-3">
                    <li class="nav-item">
                        <button class="nav-link inprogress-tab active">In-Progress Sites</button>
                    </li>
                    <li class="nav-item ${(this.cardData.metricId === 16) ? 'd-none' : ''}">
                        <button class="nav-link completed-tab">Completed Sites</button>
                    </li>
                </ul>

                <div class="dsa-tab-content inprogress-tab-content">
                    <div class="dsa-details-container">
                        <div class="dsa-details-item">
                        ${this.getSiteTable(this.redSites, `Needs Attention (More than ${this.redDays} days)`, 'dsa-red')}
                        </div>
                        <div class="dsa-details-item">
                        ${this.getSiteTable(this.yellowSites, `Worth Watching (${this.yellowDays}-${this.redDays} days)`, 'dsa-yellow')}
                        </div>
                        <div class="dsa-details-item">
                        ${this.getSiteTable(this.greenSites, `On Track (Less than ${this.yellowDays} days)`, 'dsa-green')}
                        </div>
                    </div>
                </div>
                <div class="dsa-tab-content completed-tab-content d-none">
                    <div class="dsa-details-container">
                        <div class="dsa-details-item">
                        ${this.getSiteTable(this.completedSites, `Completed`, `${this.studybglight} ${this.studyborder}`)}
                        </div>
                    </div>
                </div>
            </div>
        </div>`;

    }

    setData(data, maxSites, maxDays, minDays) {
        this.cardData = data;
        this.stoplightMax = maxSites;
        this.plotMax = maxDays;
        this.plotMin = minDays;
    }

    initializeData() {
        this.yellowDays = this.cardData.yellowDays || 9999;
        this.redDays = this.cardData.redDays || 9999;

        this.studybg = `study-${this.cardData.studyId}-bg`;
        this.studybglight = `study-${this.cardData.studyId}-bg-light`;
        this.studyborder = `study-${this.cardData.studyId}-border`;

        this.inProgress = this.cardData.inProgress || {};
        this.completed = this.cardData.completed || {};

        this.inProgressCount = this.inProgress.NumberOfSites || 0;
        this.completedCount = this.completed.NumberOfSites || 0;

        this.stoplightMax = this.stoplightMax || this.inProgressCount;

        this.minDays = this.plotMin || Math.min(this.inProgress.MinValue, this.completed.MinValue);
        this.maxDays = this.plotMax || Math.max(this.inProgress.MaxValue, this.completed.MaxValue);

        this.greenSites = this.getSitesDesc(Number.MIN_SAFE_INTEGER, this.yellowDays, 0);
        this.yellowSites = this.getSitesDesc(this.yellowDays, this.redDays, 0);
        this.redSites = this.getSitesDesc(this.redDays, Number.MAX_VALUE, 0);
        this.completedSites = this.getSitesDesc(Number.MIN_SAFE_INTEGER, Number.MAX_VALUE, 1);

    }

    getPlotMarkup(data, showYellowRed=false) {

        const minPercent = this.getPlotPercent(data.MinValue);
        const maxPercent = 100 - this.getPlotPercent(data.MaxValue);
        const q1Percent = this.getPlotPercent(data.Q1Value);
        const q3Percent = 100 - this.getPlotPercent(data.Q3);
        const medianPercent = this.getPlotPercent(data.MedianValue);
        const meanPercent = this.getPlotPercent(data.MeanValue);

        const yellowPercent = this.getPlotPercent(this.yellowDays);
        const redPercent = this.getPlotPercent(this.redDays);

        const yellowMarkup = (showYellowRed && this.yellowDays && this.yellowDays < this.maxDays && this.yellowDays > this.minDays) ? `<div class="plot-ys" style="left:${yellowPercent}%" title="${this.yellowDays} days" data-toggle="tooltip" data-placement="bottom"></div>` : '';
        const redMarkup = (showYellowRed && this.redDays && this.redDays < this.maxDays && this.redDays > this.minDays) ? `<div class="plot-rs" style="left:${redPercent}%" title="${this.redDays} days" data-toggle="tooltip" data-placement="bottom"></div>` : '';

        return `
        ${yellowMarkup}
        ${redMarkup}
        <div class="plot-w ${this.studybg}" style="left:${minPercent}%;right:${maxPercent}%;">
            <div class="plot-label-min">${(data.NumberOfSites === 1) ? '' : data.Min}</div>
            <div class="plot-label-max">${(data.NumberOfSites === 1) ? '' : data.Max}</div>
        </div>
        <div class="plot-b ${this.studybglight} ${this.studyborder}" style="left:${q1Percent}%;right:${q3Percent}%;"></div>
        <div class="plot-m" style="left:${medianPercent}%">
            <!-- <div class="plot-label-med">
                ${data.Median}
            </div> -->
        </div>
        <div class="plot-mn" style="left:${meanPercent}%">
            <div class="plot-label-mn">
                ${data.Mean}
            </div>
        </div>
        `;
    }

    getPlotMarkupNoData() {
        const yellowPercent = this.getPlotPercent(this.yellowDays);
        const redPercent = this.getPlotPercent(this.redDays);

        const yellowMarkup = (this.yellowDays && this.yellowDays < this.maxDays && this.yellowDays > this.minDays) ? `<div class="plot-ys" style="left:${yellowPercent}%" title="${this.yellowDays} days" data-toggle="tooltip" data-placement="bottom"></div>` : '';
        const redMarkup = (this.redDays && this.redDays < this.maxDays && this.redDays > this.minDays) ? `<div class="plot-rs" style="left:${redPercent}%" title="${this.redDays} days" data-toggle="tooltip" data-placement="bottom"></div>` : '';

        return `
        ${yellowMarkup}
        ${redMarkup}
        `;
    }

    getPlotPercent(value) {
        return Math.round(((value - this.minDays) / (this.maxDays - this.minDays)) * 100);
    }

    getStoplightPercent(value) {
        return Math.round((value / this.stoplightMax) * 100);
    }

    getStoplightMarkup() {

        const greenCount = this.cardData.sites.filter((site) => ((site.CompletedId === 0) && (site.DaysValue < this.yellowDays))).length;
        const yellowCount = this.cardData.sites.filter((site) => ((site.CompletedId === 0) && (site.DaysValue >= this.yellowDays) && (site.DaysValue < this.redDays))).length;
        const redCount = this.cardData.sites.filter((site) => ((site.CompletedId === 0) && (site.DaysValue >= this.redDays))).length;

        const greenPercent = this.getStoplightPercent(greenCount);
        const yellowPercent = this.getStoplightPercent(yellowCount);
        const redPercent = this.getStoplightPercent(redCount);

        return `
        ${this.getStoplightBandMarkup('green', greenPercent, greenCount)}
        ${this.getStoplightBandMarkup('yellow', yellowPercent, yellowCount)}
        ${this.getStoplightBandMarkup('red', redPercent, redCount)}
        `;
    }

    getStoplightBandMarkup(color, percent, count) {
        const label = `${count} Site${(count === 1) ? '' : 's'}`;
        return (percent > 0) ? `
        <div class="dsa-stoplight-bar dsa-${color}" style="width: ${percent}%;" title="${label}" data-toggle="tooltip" data-placement="top">
            <div class="dsa-stoplight-spacer"></div>
            <div class="dsa-stoplight-label">${label}</div>
        </div>
        ` : '';
    }

    getCompletedLabelMarkup(completedPercent) {
        if (this.cardData.metricId === 16) return ''; // Don't show Completed for "Time Since Most Recent Randomization"
        return `<span class="dsa-timeline-label-count">${this.completedCount}</span> <span class="dsa-timeline-label-percent">(${completedPercent.toFixed()}%)</span> Sites <br>Completed`;
    }

    getSitesDesc(startDays, endDays, completedId) {
        return this.getSites(startDays, endDays, completedId).sort((a,b) => b.DaysValue - a.DaysValue)
    }

    getSites(startDays, endDays, completedId) {
        return this.cardData.sites.filter((site) =>
            ((site.DaysValue >= startDays) &&
            (site.DaysValue < endDays) &&
            (site.CompletedId === completedId))
        );
    }

    getSiteTable(sites, title, cssClass) {

        const siteCount = sites.length;
        const siteString = (siteCount === 1) ? 'Site' : 'Sites'

        const tableRows = sites.map((site) => {
            return `
            <tr onclick="page.showDashboardModal(${site.SiteId},${site.StudyId},${site.MetricId}, ${site.AppendixA}, ${site.AppendixB})">
                <td>${site.SiteName} (${site.SiteIdDisplay})</td>
                <td>${site.Days} days</td>
            </tr>
            `;
        }).join('');

        return `
        <div class="dsa-details-header ${cssClass}">
            ${title}
            <div class="dsa-details-count">${siteCount} ${siteString}</div>
        </div>
        <div class="dsa-details-table-container">
        <table>
            ${tableRows}
        </table>
        </div>
        `;
    }

    getPopoverOptions(data, title): PopoverOption {
        return {
            html: true,
            title: title,
            content: `
                <div>
                <table>
                    <tr>
                        <th class="text-left pr-3">Min:</th>
                        <td class="text-right">${data.Min}</td>
                    </tr>
                    <tr>
                        <th class="text-left pr-3">Q1:</th>
                        <td class="text-right">${data.Q1}</td>
                    </tr>
                    <tr>
                        <th class="text-left pr-3">Mean:</th>
                        <td class="text-right">${data.Mean}</td>
                    </tr>
                    <tr>
                        <th class="text-left pr-3">Median:</th>
                        <td class="text-right">${data.Median}</td>
                    </tr>
                    <tr>
                        <th class="text-left pr-3">Q3:</th>
                        <td class="text-right">${data.Q3}</td>
                    </tr>
                    <tr>
                        <th class="text-left pr-3">Max:</th>
                        <td class="text-right">${data.Max}</td>
                    </tr>
                </table>
                </div>`,
            delay: { "show": 500, "hide": 100 },
            sanitize: false,
            trigger: 'hover',
            placement: 'top'
        }
    }

    updatedDetailsTabs() {
        const activeTab = (this.detailsTabState) ? this.inprogressTab : this.completedTab;
        const activeTabContent = (this.detailsTabState) ? this.inprogressTabContent : this.completedTabContent;
        const inactiveTab = (this.detailsTabState) ? this.completedTab : this.inprogressTab;
        const inactiveTabContent = (this.detailsTabState) ? this.completedTabContent : this.inprogressTabContent;

        activeTab.classList.add('active');
        inactiveTab.classList.remove('active');
        activeTabContent.classList.remove('d-none');
        inactiveTabContent.classList.add('d-none');
    }


}

